import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const DataExplorerApi = {
  store(type) {
    return http.post(`${orgPath()}/data-explorer`, { type }).then((response) => response.data.data);
  },
};
